export const COMMENT_MAX_IMAGES = 10;
export const COMMENT_MIN_SIZE_KB = 1;
export const COMMENT_MAX_SIZE_KB = 10240;
